export default {
  navbar: {
    changePassword: 'Changer le mot de passe',
    logout: 'Se déconnecter',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    pleaseEnterOldPassword: 'Veuillez saisir l’ancien mot de passe',
    pleaseEnterNewPassword: 'Veuillez saisir le nouveau mot de passe',
    pleaseConfirmNewPassword: 'Veuillez confirmer le nouveau mot de passe',
    save: 'Enregistrer',
    cancel: 'Annuler',
    passwordRequired: 'Veuillez saisir le mot de passe',
    newPasswordRequired: 'Veuillez saisir le nouveau mot de passe',
    confirmPasswordRequired: 'Veuillez confirmer le mot de passe',
    passwordTooShort: 'Le mot de passe ne peut pas contenir moins de 6 caractères',
    passwordsMismatch: 'Les deux mots de passe ne correspondent pas',
    changePasswordSuccess: 'Mot de passe modifié avec succès',
    changePasswordFailed: 'Échec de la modification du mot de passe'
  },
  role: {
    roleName: 'Role Name',
    createTime: 'create Time',
    roleNumber: 'Role Number',
    roleDescription: 'Role Description'
  },
  global: {
    pleaseEnter: 'Please Enter',
    enter: 'Please Enter',
    query: 'Query',
    reset: 'Reset',
    add: 'Add',
    total: 'Total',
    item: 'Item',
    action: 'Actions',
    status: 'Status',
    startDate: 'Start Date',
    endDate: 'End Date'
  },
  enterprise: {
    companyNameLabel: 'Nom de la société',
    statusLabel: 'Statut',
    submissionTimeLabel: 'Date de soumission',
    companyName: 'Nom de l\'entreprise',
    contactName: 'Nom du contact',
    globalVatNo: 'Numéro de TVA mondial',
    eori: 'EORI',
    submissionTime: 'Date de soumission',
    reviewTime: 'Date de révision',
    approve: 'Approuver',
    reject: 'Rejeter',
    confirmApprove: 'Êtes-vous sûr d\'approuver ?',
    rejectionsReason: 'Raison du rejet',
    inputReason: 'Veuillez entrer la raison',
    submitSuccess: 'Soumission réussie !',
    pendingStatus: 'En attente',
    submittedStatus: 'Soumis',
    approvedStatus: 'Approuvé',
    rejectedStatus: 'Rejeté',
    verificationRequired: 'Veuillez d\'abord compléter la vérification de votre entreprise. L\'accès sera accordé après approbation.',
    rejectedTip: 'La vérification du dossier de l\'entreprise a échoué. Motif : {remark}. Veuillez modifier les informations puis soumettre à nouveau.',
    submittedTip: 'Le dossier de l\'entreprise a été soumis et est en cours d\'examen. Veuillez patienter.',
    approvedTip: 'Le dossier de l\'entreprise a été approuvé. Toutes les fonctionnalités du système sont désormais disponibles.',
    companyInfo: 'Informations sur l\'entreprise',
    companyAddress: 'Adresse de l\'entreprise',
    incorporationDate: 'Date d\'incorporation',
    contactInfo: 'Coordonnées',
    email: 'Email',
    phoneNumber: 'Numéro de téléphone',
    taxInfo: 'Informations fiscales',
    remarks: 'Remarques',
    paymentInfo: 'Informations de paiement',
    paymentType: 'Type de paiement',
    paymentMethodA: 'A',
    paymentMethodE: 'E',
    paymentMethodP: 'P',
    paymentMethodBankTransfer: 'Virement bancaire',
    paymentMethodCreditCard: 'Carte de crédit',
    paymentMethodSepa: 'SEPA',
    pleaseSelect: 'Veuillez sélectionner',
    paymentRefNumber: 'Numéro de référence de paiement',
    defaultFlag: 'Indicateur par défaut',
    add: '+ Ajouter',
    delete: 'supprimer',
    edit: 'Modifier',
    cancel: 'Annuler',
    locationInfo: 'Informations sur l\'emplacement',
    locationName: 'Nom de l\'emplacement',
    locationCode: 'Code de l\'emplacement',
    submit: 'Soumettre',
    emailCorrect: 'Veuillez entrer un email correct',
    submitSuccessful: 'Soumission réussie',
    submitFailed: 'Échec de la soumission',
    submitFailedMsg: 'Échec de la soumission : ',
    unknownError: 'Erreur inconnue',
    completeFields: 'Veuillez remplir tous les champs obligatoires',
    paymentTypeRow: 'Veuillez sélectionner le type de paiement pour la ligne ',
    paymentRefRow: 'Veuillez entrer le numéro de référence de paiement pour la ligne ',
    oneDefaultRequired: 'Au moins un mode de paiement doit être défini comme par défaut',
    locationNameRow: 'Veuillez entrer le nom de l\'emplacement pour la ligne ',
    locationCodeRow: 'Veuillez entrer le code de l\'emplacement pour la ligne '
  },
  h7: {
    toDeclare: '待申报',
    declaring: '处理中',
    rejected: '申报错误',
    declared: '已申报',
    accepted: '已受理',
    checking: '查验',
    release: '放行',
    gotIt: 'Got it',
    shippingReference: 'Référence d\'expédition',
    lrnLabel: 'LRN',
    correlationId: 'ID de corrélation',
    userId: 'Identifiant utilisateur'
  },
  batch: {
    importData: 'Import Data',
    consignee: 'Consignor',
    hsQty: 'HS Qty',
    parcelQty: 'Parcel Qty',
    toDeclare: 'To declare',
    inProcess: 'In process',
    sent: 'Sent',
    release: 'Release',
    inControl: 'In Control',
    rejected: 'Rejected',
    actions: 'Actions',
    declare: 'Declare',
    delete: 'Delete',
    exportErrors: 'Export Errors',
    statusReport: 'Status Report',
    downloadManifest: 'Download Manifest',
    importErrors: 'Import Errors',
    confirm: 'Confirm',
    cancel: 'Cancel',
    back: 'Back',
    areYouSureToDeclare: 'Are you sure to declare?',
    areYouSureToDelete: 'Are you sure to delete?',
    declareSuccessful: 'Declare successful',
    deleteSuccessful: 'Delete successful',
    clickToUpload: 'Click to upload files or drag files here',
    downloadTemplate: 'Download Import Template',
    gotIt: 'Got it',
    systemProcessing: 'System is processing the data...',
    waitUploadComplete: 'Please wait for the upload to complete.',
    closeIfUrgent: 'If you need to handle other urgent tasks, you may close this popup.',
    checkDocumentCenter: 'You can check the import result later in the Document Center.',
    uploadSuccessful: 'Upload is successful',
    uploadFailed: 'Upload is failed',
    verificationFailed: 'Notice: verification of data is failed.',
    clickDownloadOrShift: 'Click here',
    orShiftToImportTask: 'or Shift to Import Task in File Center at upper right download result file with error message.',
    checkErrorMessage: 'Check the Error Message at the last column of Result File, and modify the data in original template you tend to upload again.',
    reuploadAfterCorrect: 'Re-upload after all errors are corrected or removed.'
  },
  taskPane: {
    success: 'Succès',
    failure: 'Échec',
    loading: 'Chargement...',
    noMore: 'Plus de données'
  },
  menu: {
    menuList: 'Liste des menus',
    addMenu: 'Ajouter un menu',
    menuEdit: 'Modification du menu',
    menuName: 'Nom du menu',
    pleaseEnterMenuName: 'Veuillez entrer le nom du menu',
    languageKey: 'Nom multilingue',
    pleaseEnterMultiLanguageFormat: 'Veuillez entrer le format suivant, par ex. : $tr("submit", "Soumettre")',
    menuType: 'Type de menu',
    directory: 'Répertoire',
    menu: 'Menu',
    permission: 'Permission',
    portal: 'Portal',
    routePath: 'Chemin de la route',
    pleaseEnterRoutePath: 'Veuillez entrer le chemin de la route',
    pleaseEnterPermission: 'Veuillez entrer la permission',
    parentMenu: 'Menu parent',
    pleaseSelectParentMenu: 'Veuillez sélectionner le menu parent',
    none: 'Aucun',
    displayOrder: 'Ordre d\'affichage',
    pleaseEnterOrderNumber: 'Veuillez entrer le numéro de commande',
    menuIcon: 'Icône du menu',
    pleaseEnterMenuIcon: 'Veuillez entrer l\'icône du menu',
    visible: 'Visible',
    show: 'Afficher',
    hide: 'Masquer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    pleaseSelectMenuToEdit: 'Veuillez sélectionner un menu dans la liste de gauche pour modifier',
    createMenu: 'Créer un menu',
    confirm: 'Confirmer',
    pleaseEnterUserName: 'Veuillez entrer le nom d\'utilisateur',
    pleaseSelectMenuType: 'Veuillez sélectionner le type de menu',
    pleaseSelectParentMenuFirst: 'La permission doit sélectionner le menu parent',
    updateSuccess: 'Mise à jour réussie',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce menu ?',
    prompt: 'Invite',
    deleteSuccess: 'Suppression réussie',
    addSuccess: 'Ajout réussi'
  }
}
